export default "__VITE_ASSET__B33SMZvE__"